export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading font-bold tracking-tight">
              51<span className="text-accent-400">cg</span>
            </span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              51cg今日大瓜必吃大瓜合集，覆盖51cgfun今日吃瓜、51cg.fun今日吃瓜及51cg吃瓜热点事件。
              娱乐爆料与大瓜速递一网打尽，紧跟朝阳群众吃瓜动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '吃瓜专题', href: '#index' },
                { label: '吃瓜热榜', href: '#ranking' },
                { label: '焦点专题', href: '#carousel' },
                { label: '实时快讯', href: '#updates' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {[
                { label: '关于51cg', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '移动吃瓜', href: '#app' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              感谢各位合作伙伴的支持与信任。如有合作意向，欢迎通过
              <a href="#contact" className="text-accent-400 hover:text-accent-300 cursor-pointer">联系我们</a>
              页面详询。
            </p>
          </div>
        </div>

        <div className="py-5 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 51cg.fun 版权所有 | 51cgfun今日吃瓜 · 51cg.fun今日吃瓜 · 51cg吃瓜
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-400">51cg今日大瓜必吃大瓜</span>
              <span className="text-xs text-foreground-400">51cg最新吃瓜</span>
              <span className="text-xs text-foreground-400">51cg娱乐爆料</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}